'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1App8 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module1,
    app: state.moduleData.data.module1.app8
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App8, _Component);

  function Module1App8() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App8);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App8.__proto__ || (0, _getPrototypeOf2.default)(Module1App8)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 10,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'What is a non-core food?',
      types: {
        app: 0,
        extra: 1,
        activity: 2
      }
    }, _this.handleOnClick = function (module, modtype, item, event) {
      event.preventDefault();
      _this.props.changeItem(module, modtype, item);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 1, 8, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // used to navigate to a resource item


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1App8, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var partyFoodsImg = require('../Assets/partyFoods.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'We have talked about core foods \u2013 fruit, vegetables, grains, meat, legumes, dairy and alternatives. Core foods are represented in the Healthy Food Pyramid due to their high nutrition value.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Non core foods are \u2018junk foods\u2019. These foods are higher in kilojoules, sugar, saturated fats and added salt, and lower in fibre than \u2018core\u2019 foods.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/module1', onClick: this.handleOnClick.bind(this, 1, this.state.types.extra, 7) },
              'Click here '
            ),
            'to learn how to know if a food is high in sugar, fat, salt and low in fibre \u2013 understanding nutrition information panels. The Australian Government describes non-core foods and drinks as \u2018discretionary choices\u2019. This is because they are not a necessary part of our diet.'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Non core foods are discretionary choices'
          ),
          _react2.default.createElement(ReactBootstrap.Image, { src: partyFoodsImg, className: styles.image60 + ' center-block', responsive: true }),
          _react2.default.createElement(
            'p',
            null,
            'These are deliberately NOT part of the healthy eating pyramid because we should only eat these \'sometimes\' and in small amounts.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/module1', onClick: this.handleOnClick.bind(this, 1, this.state.types.extra, 6) },
              'Click here'
            ),
            ' for a full list of discretionary foods and appropriate serve sizes.'
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Non-core foods as snacks'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'For many children, the majority of their non-core or discretionary food intake comes from snacks.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Snacks advertised for children are often highly processed and contain large amounts of sugar, salt or fat, e.g. cereal bars, chips, muffins and chocolate bars.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'As a general rule of thumb, \'fresh is best\' for both meals and snacks.'
                )
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Of course, it is OK to provide non-core foods sometimes - however developing healthy habits around having core foods as snacks rather than non-core items is important, especially during childhood.'
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module1App8;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module1App8;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App8.js
// module id = 1171
// module chunks = 0